//import settings from '../settings.js'

const $inject = ['$scope', 'common', '$cordovaDatePicker', '$compile', '$ionicPopup']

function DatePickerCtrl(scope, common, cordovaDatePicker, compile, ionicPopup) {
    scope.show = function (event) {
        const target = event.target;

        let format = typeof scope.format !== 'undefined' ? scope.format : 'DD.MM.YYYY',
            options = typeof scope.options !== 'undefined' ? scope.options : {
                date: new Date(),
                mode: 'date', // or 'time'
                allowOldDates: true,
                allowFutureDates: false,
                doneButtonLabel: 'DONE',
                doneButtonColor: '#000000',
                cancelButtonLabel: 'CANCEL',
                cancelButtonColor: '#000000'
            };

        if (scope.date && scope.date.length > 0)
            options.date = moment(scope.date, format).toDate();

        let openPopupCalendar = () => {
            return new Promise((resolve, reject) => {
                const customTemplate = `<ion-content style="background-color: #fff;"><responsive-calendar></ion-content>`;
    
                scope.calendarPopupResolve = resolve;
    
                scope.calendarPopup = ionicPopup.show({
                    template: (compile(customTemplate)(scope)).html(), //Compile before popup.
                    title: _locale('select date').ucfirst(),
                    cssClass: 'popupCalendar',
                    scope: scope,
                    buttons: [{
                        text: _locale('cancel').ucfirst(),
                        onTap: (e) => {
                            resolve(false);                            
                        } 
                    }]
                });
            });
        };

        openPopupCalendar().then((date) => {
            if (date)
                scope.date = moment(date, 'DD.MM.YYYY').format(format);
        });
        
    };
}

DatePickerCtrl.$inject = $inject

function DatePicker() {
    if (typeof moment !== 'function')
        console.warn('wnioDatePicker: MomentJS is not loaded');

    return {
        restrict: 'A',
        replace: true,
        template: '<input type="text" class="popupCalendarDisabled" ng-readonly="true" ng-click="show($event)" placeholder="{{ format || \'DD.MM.YYYY\' }}" ng-model="date" />', //ng-show="show($event)"
        scope: { date: '=wnioDatePicker', options: '=?', format: '<?' },
        controller: DatePickerCtrl
    };
}

export default DatePicker